import { render, staticRenderFns } from "./SupplierDue.vue?vue&type=template&id=5e2bc524&scoped=true&"
import script from "./SupplierDue.vue?vue&type=script&lang=js&"
export * from "./SupplierDue.vue?vue&type=script&lang=js&"
import style0 from "./SupplierDue.vue?vue&type=style&index=0&id=5e2bc524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2bc524",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VCombobox,VContainer,VDivider,VForm,VRow,VSimpleTable})
